import { render, staticRenderFns } from "./ApproveSalesNote.vue?vue&type=template&id=146f543c&"
import script from "./ApproveSalesNote.vue?vue&type=script&lang=js&"
export * from "./ApproveSalesNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports